import * as React from 'react';
import { EmojiElement } from './Emoji.styles';

var Emoji = props => /*#__PURE__*/React.createElement(EmojiElement, {
  className: "emoji",
  role: "img",
  "aria-label": props.label ? props.label : '',
  "aria-hidden": props.label ? 'false' : 'true'
}, props.symbol);

export { Emoji };
//# sourceMappingURL=Emoji.js.map